import HighlightWord from "../../../../src/components/HighlightWord";
import * as React from 'react';
export default {
  HighlightWord,
  React
};